export const FollowUpChannels = {
  sms: 'SMS',
  facebook: 'FB Messenger',
  webchat: 'Webchat',
  instagram: 'Instagram',
};
export type FollowUpChannel = keyof typeof FollowUpChannels;

export type QqFollowUpModel = {
  pageId: number;
  botId: number;
  interval: number;
  status: 'paused' | 'active';
  platforms: FollowUpChannel[];
};

export type FollowUpKind =
  | 'qq_follow_up'
  | 'pending_follow_up'
  | 'resolved_follow_up';
export type FollowUpStateType =
  | 'qqFollowUps'
  | 'pendingFollowUps'
  | 'resolvedFollowUps';

export type FollowUpModel<T> = {
  id: number;
  kind: FollowUpKind;
  sortOrder: number;
} & T;

export const entityTypeByKind: Record<FollowUpKind, FollowUpStateType> = {
  qq_follow_up: 'qqFollowUps',
  pending_follow_up: 'pendingFollowUps',
  resolved_follow_up: 'resolvedFollowUps',
};

export const kindByEntityType: Record<FollowUpStateType, FollowUpKind> = {
  qqFollowUps: 'qq_follow_up',
  resolvedFollowUps: 'resolved_follow_up',
  pendingFollowUps: 'pending_follow_up',
};

export type FollowUpByKindMap = {
  qq_follow_up: FollowUpModel<QqFollowUpModel>;
};
